module.exports = __webpack_public_path__ + "static/bg-welcome-0b24280d1b81c85736a8c5f9d2364473.jpg";